<template>
  <v-card>
    <v-img
      :src="image"
      aspect-ratio="2.75"></v-img>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{title}}</h3>
        <div>{{description}}</div>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-btn flat @click="$emit('click')">VOIR</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  export default {
    props: ['image', 'title', 'description'],
  }
</script>
